/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Title_SessionInputs */

const en_us2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap for today only`)
};

const pt_br2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar só hoje`)
};

const es_419_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar solo hoy`)
};

const pt_pt2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar só hoje`)
};

const fr_fr2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer pour aujourd'hui`)
};

const de_de2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur heute tauschen`)
};

const it_it2_swap_title_session = /** @type {(inputs: Swap_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia solo per oggi`)
};

/**
* | output |
* | --- |
* | "Swap for today only" |
*
* @param {Swap_Title_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_title_session = /** @type {((inputs?: Swap_Title_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Title_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_title_session(inputs)
	if (locale === "es-419") return es_419_swap_title_session(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_title_session(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_title_session(inputs)
	if (locale === "de-DE") return de_de2_swap_title_session(inputs)
	if (locale === "it-IT") return it_it2_swap_title_session(inputs)
	return en_us2_swap_title_session(inputs)
});
export { swap_title_session as "swap.title_session" }